import Share from '@/components/Common/Share';
import { observer } from 'mobx-react-lite';
import React, { FC, useContext } from 'react';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import { getSVG } from '@/components/Common/styles/mixins';

const NolPromotionShare: FC = () => {
  const store = useContext(NolPromotionStoreCtx);
  const { promotionUrl, promotionDeeplink } = store;

  // update settings
  const shareKakaoContent: Kakao.Link.DefaultFeedSettings = {
    objectType: 'feed',
    content: {
      title: '놀수록 놀라운 혜택 NOL 카드',
      imageUrl: getSVG('/static/images/nol-promotion/v7/meta-img-square.png'),
      imageWidth: 360,
      imageHeight: 360,
      link: {
        webUrl: promotionUrl,
        mobileWebUrl: promotionDeeplink,
      },
    },
    buttons: [
      {
        title: '웹에서 보기',
        link: {
          webUrl: promotionUrl,
          mobileWebUrl: promotionUrl,
        },
      },
    ],
  };

  const smsMessage = `놀 사람을 위한 NOL 카드!`;

  return (
    <Share
      isOpen={store.isShareModalOpen}
      kakaoSettings={shareKakaoContent}
      onRequestClose={() => (store.isShareModalOpen = false)}
      hideFacebook={true}
      url={promotionUrl}
      deeplink={promotionDeeplink}
      smsMessage={smsMessage}
    />
  );
};

export default observer(NolPromotionShare);
